import { render, staticRenderFns } from "./AdminWelcomeWestudy_Courses.vue?vue&type=template&id=2e1d8ebb&scoped=true&"
import script from "./AdminWelcomeWestudy_Courses.vue?vue&type=script&lang=js&"
export * from "./AdminWelcomeWestudy_Courses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d8ebb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
